import { render, staticRenderFns } from "./CourseDiscussion.vue?vue&type=template&id=935c85c4&scoped=true"
import script from "./CourseDiscussion.vue?vue&type=script&lang=js"
export * from "./CourseDiscussion.vue?vue&type=script&lang=js"
import style0 from "./CourseDiscussion.vue?vue&type=style&index=0&id=935c85c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935c85c4",
  null
  
)

export default component.exports